import React, {useState} from 'react';
import {Link, Navigate} from 'react-router-dom';
import './novaconta.css';

import firebase from '../Config/firebase';
import {getAuth, createUserWithEmailAndPassword} from 'firebase/auth';
import { collection, getFirestore, query, where, getDocs } from 'firebase/firestore';

function NovaConta(){
    const [email,setEmail] = useState('');
    const [senha,setSenha] = useState('');
    const [mensagem,setMensagem] = useState('');
    const [sucesso,setSucesso] = useState('');
    const [cpf,setCpf] = useState('');
    const [p1,setP1] = useState('');
    const [tipo,setTipo] = useState('');
    const [succpf,setSuccpf] = useState('N');
    const [setrota,setRota] = useState('');
    const [setcam,setCam] = useState('');
    const auth = getAuth();

    function CheckFili(){
      setMensagem('');
      setSuccpf('');
      if (!cpf){
         setMensagem('Informe o CPF');
         return;
        }
      if (!sucesso){
        return;
      }
      const fetchData = async () => {
          const db = getFirestore();
          const q = query(collection(db, 'clientes'), where('cpf', '==', cpf));
          const querySnapshot = await getDocs(q);
          querySnapshot.forEach((doc) => {
             // doc.data() is never undefined for query doc snapshots
             setMensagem('OK! Prossiga com a autenticação.');
             setP1(doc.id);
             setTipo(doc.data().tipo);
             setSuccpf('S');
             setMensagem('Filiação Confirmada.')
             if (doc.data().tipo === 'A') {setCam('A')} else {setCam('B')}
             console.log("Documento ==> ", p1);
             console.log("Variavel cpf ==> ", succpf);
          });
          }
          fetchData();
          }

    function cadastrarUsuario(){
     setMensagem('');
     if (!email || !senha){
        setMensagem('Informe todos os campos');
        return;
     }
  
     createUserWithEmailAndPassword(auth,email,senha)
     .then(resultado => {

         setSucesso('S');
     })
     .catch(error => {
        setSucesso('');
        if (error.message === 'Firebase: Password should be at least 6 characters (auth/weak-password).') {
           setMensagem('A senha precisa ter 6 caracteres');}
        else if (error.message === 'Firebase: Error (auth/invalid-email).') {
           setMensagem('O email não é válido');}
        else if (error.message === 'Firebase: Error (auth/email-already-in-use).') {
           setMensagem('Esse email já está em uso por outra conta');}
        else {
            setMensagem('Erro ao criar conta' + error.message);}   
     })

    }

    function alterarEmail(event){
        setEmail(event.target.value);
    }

    function alterarSenha(event){
        setSenha(event.target.value);
    }

    function alterarCpf(event){
      setCpf(event.target.value);
  }

  function OpeninNewTab(){
    const txteproc = 'https://www.sintuff.org.br/post/saiba-como-se-filiar-ao-sintuff-pela-internet';
    const win = window.open(txteproc, '_blank');
  }

    return <div className="tstcor1">
           <div className="mm2">
           <form>
            <img className="tstimg2" src="/images/logo8.png" alt="" />
            <h1 className="testeh6">Informe o seu e-mail e uma senha de 6 dígitos para criar uma conta</h1>
            
            <div className="form-floating">
            <input onChange={alterarEmail} type="email" className="form-control inptlg4" id="floatingInput" placeholder="E-mail" />
            <label className="flt2" htmlFor="floatingInput">E-mail</label>
            </div>
            <div className="form-floating">
            <input onChange={alterarSenha} type="password" className="form-control inptlg4" id="floatingPassword" placeholder="Senha" />
            <label className="flt2" htmlFor="floatingPassword">Senha</label>
            </div>

            <button onClick={() => {cadastrarUsuario()}} className="btn btn-primary py-2 butace4" type="button">Criar conta</button>

            <h1 className="testeh7">Em seguida informe seu CPF</h1>
            <h1 className="testeh8">(apenas números)</h1>

            <div className="input-group mt-4"> 
            <input onChange={alterarCpf} type="text" className="form-control tsti3" id="floatingInput" maxLength={11} placeholder="CPF" />
            <button onClick={CheckFili} className="btn btn-primary butcpf4" type="button">Verificar Cadastro</button>
            </div>
        
            {mensagem.length>0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {setcam==='B' ? <Navigate to={'/app/mostrarprocesso/' + p1} /> : null} 
            {setcam==='A' ? <Navigate to='/app/home' /> : null}

            <div className="roda1">
                <Link to="/app" className="mx-3 lnk7">Já tenho uma conta</Link> 
                <button onClick={OpeninNewTab} type="button" className="btn btn-primary mt-2 teste-lb">Filie-se ao SINTUFF</button>
            </div>
            <p className="mt-3 mb-3 text-white-50 tstcopy2">&copy; Desenvolvido por Fernando Barros</p>
           </form>
          </div>
        </div>;
  }

  export default NovaConta;